import styled from '@emotion/styled';
// --- Styled Components (CSS 변수 사용) ---
export const PracticeContainer = styled.div(({ theme })=>({
        borderLeft: `4px solid var(--theme-primary)`,
        borderRadius: `var(--theme-radius-md)`,
        padding: theme.spacing.lg,
        margin: `${theme.spacing.lg} 0`,
        backgroundColor: `var(--my-card-background)`,
        boxShadow: `var(--theme-shadows-sm, var(--theme-shadow))`,
        // 반응형: 작은 화면에서 패딩/마진 최소화, 좌측 테두리 유지 및 하단 구분선 추가
        [`@media (max-width: ${theme.breakpoints.sm})`]: {
            padding: `${theme.spacing.xs} ${theme.spacing.xs}`,
            margin: `${theme.spacing.xs} 0`,
            borderRadius: 0,
            borderLeft: `2px solid var(--theme-primary)`,
            boxShadow: 'none',
            borderBottom: `1px solid var(--theme-border)`
        }
    }));
export const Header = styled.h3(({ theme })=>({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.sm,
        marginTop: 0,
        marginBottom: theme.spacing.md,
        color: `var(--theme-primary)`,
        fontSize: theme.typography.fontSize.lg,
        // 반응형: 작은 화면에서 폰트 크기, 간격 조정 및 마진 최소화
        [`@media (max-width: ${theme.breakpoints.sm})`]: {
            fontSize: theme.typography.fontSize.base,
            gap: theme.spacing.xs,
            marginBottom: theme.spacing.xs
        }
    }));
export const PracticeTypeHeader = styled.div(({ theme })=>({
        padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
        marginBottom: theme.spacing.lg,
        backgroundColor: `var(--theme-paper-light)`,
        borderBottom: `1px solid var(--theme-border)`,
        borderTop: `1px solid var(--theme-border)`,
        textAlign: 'center',
        color: `var(--theme-text-secondary)`,
        fontSize: theme.typography.fontSize.sm,
        fontWeight: theme.typography.fontWeight.medium,
        [`@media (max-width: ${theme.breakpoints.sm})`]: {
            padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
            fontSize: theme.typography.fontSize.xs,
            marginBottom: theme.spacing.sm
        }
    }));
export const Section = styled.div(({ theme })=>({
        marginBottom: theme.spacing.lg,
        // 반응형: 작은 화면에서 마진 최소화
        [`@media (max-width: ${theme.breakpoints.sm})`]: {
            marginBottom: theme.spacing.xs
        }
    }));
export const SectionTitle = styled.h4(({ theme })=>({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.sm,
        marginBottom: theme.spacing.sm,
        fontWeight: theme.typography.fontWeight.semibold,
        color: `var(--theme-text)`,
        fontSize: theme.typography.fontSize.base,
        // 반응형: 작은 화면에서 폰트 크기, 간격 및 마진 최소화
        [`@media (max-width: ${theme.breakpoints.sm})`]: {
            fontSize: theme.typography.fontSize.sm,
            gap: theme.spacing.xs,
            marginBottom: theme.spacing.xs
        }
    }));
// 마크다운 내용 래퍼
export const MarkdownContentWrapper = styled.div(({ theme })=>({
        backgroundColor: `var(--my-post-background)`,
        border: `1px solid var(--theme-border-light)`,
        borderRadius: `var(--theme-radius-sm)`,
        padding: theme.spacing.md,
        fontSize: theme.typography.fontSize.sm,
        color: `var(--theme-text-secondary)`,
        lineHeight: 1.6,
        // 내부 마크다운 요소 스타일
        ul: {
            paddingLeft: theme.spacing.lg,
            margin: `${theme.spacing.sm} 0`
        },
        ol: {
            paddingLeft: theme.spacing.lg,
            margin: `${theme.spacing.sm} 0`
        },
        li: {
            marginBottom: theme.spacing.xs
        },
        p: {
            marginBottom: theme.spacing.sm,
            '&:last-child': {
                marginBottom: 0
            }
        },
        code: {
            backgroundColor: `var(--theme-paper-dark)`,
            padding: '0.2em 0.4em',
            borderRadius: `var(--theme-radius-sm)`,
            fontSize: '0.9em',
            fontFamily: theme.typography.fontFamily
        },
        // 반응형: 작은 화면에서 패딩, 폰트 크기 조정
        [`@media (max-width: ${theme.breakpoints.sm})`]: {
            padding: theme.spacing.xs,
            fontSize: theme.typography.fontSize.xs
        }
    }));
export const StartButton = styled.button(({ theme })=>({
        backgroundColor: `var(--theme-primary)`,
        color: `var(--theme-primary-text)`,
        border: 'none',
        padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
        borderRadius: `var(--theme-radius-md)`,
        cursor: 'pointer',
        fontSize: theme.typography.fontSize.base,
        fontWeight: theme.typography.fontWeight.semibold,
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing.xs,
        transition: `background-color ${theme.transition.fast}`,
        marginTop: theme.spacing.md,
        '&:hover:not(:disabled)': {
            backgroundColor: `var(--theme-primary-dark)`
        },
        '&:disabled': {
            backgroundColor: `var(--theme-paper-active)`,
            cursor: 'not-allowed',
            opacity: 0.7
        }
    }));
export const TimerDisplay = styled.div(({ theme, timeUp })=>({
        fontSize: theme.typography.fontSize.xl,
        fontWeight: theme.typography.fontWeight.bold,
        color: timeUp ? `var(--theme-error)` : `var(--theme-success)`,
        marginTop: theme.spacing.lg,
        textAlign: 'center',
        padding: theme.spacing.md,
        backgroundColor: `var(--my-post-background)`,
        borderRadius: `var(--theme-radius-sm)`,
        border: `1px solid ${timeUp ? `var(--theme-error)` : `var(--theme-success)`}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing.sm
    }));
export const ErrorMessage = styled.div(({ theme })=>({
        color: `var(--theme-error)`,
        backgroundColor: `var(--theme-error-bg, ${theme.isDark ? 'rgba(239, 68, 68, 0.2)' : '#f8d7da'})`,
        padding: theme.spacing.md,
        borderRadius: `var(--theme-radius-sm)`,
        marginBottom: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.xs
    }));
export const WorkspaceControlContainer = styled.div(({ theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing.sm,
        marginTop: theme.spacing.md,
        padding: theme.spacing.sm
    }));
export const ResultDisplay = styled.div`
    /* 결과 표시 스타일 */
`;
